<template>
  <div class="language-selector">
    <button
        v-for="lang in availableLanguages"
        :key="lang"
        @click="onLanguageChange(lang)"
        :class="{'selected': lang === language}"
    >
      {{ lang[0].toUpperCase() }}
    </button>
  </div>
</template>

<script>
export default {
  props: {
    language: String,
    onLanguageChange: Function
  },
  data() {
    return {
      availableLanguages: ['de', 'fr', 'it'],
    };
  }
};
</script>
